import HttpService from './HttpService';

const VesselsApi = HttpService('/api/vessels/');
const doPost = (action, data) => VesselsApi.post(action, data);
const doGet = (url) => VesselsApi.get(url);
const doDelete = (url) => VesselsApi.delete(url);

export default {
  getVessels(activeSiteId) {
    const queryString = `activeSiteId=${activeSiteId}`;
    const apiAction = 'GetVessels';
    const fullUrl = queryString ? `${apiAction}?${queryString}` : apiAction;
    return doGet(fullUrl);
  },
  createVessel(vessel) {
    const queryString = null;
    const apiAction = 'CreateVessel';
    const fullUrl = queryString ? `${apiAction}?${queryString}` : apiAction;
    return doPost(fullUrl, vessel);
  },
  updateVessel(vesselUpdate) {
    const apiAction = 'UpdateVessel';
    return doPost(apiAction, vesselUpdate);
  },
  deleteVessel(id) {
    const apiAction = 'DeleteVessel';
    const queryString = `id=${id}`;
    const fullUrl = queryString ? `${apiAction}?${queryString}` : apiAction;
    return doDelete(fullUrl);
  },
};
